<template>
  <div class="tw-container tw-mx-auto tw-pt-8">
    <ForeignersLogsFilters
      class="tw-mb-6"
    />
    <LogsTable
      :data="logs"
      :on-sort-change="sortChange"
    />

    <i-button
      v-if="$store.state.v2.admin.foreigners.logs.hasNext"
      :is-loading="isMoreLoading"
      class="tw-mx-auto tw-my-4"
      @click="loadMore"
    >
      {{ $t('common.actions.load_more') }}
    </i-button>
  </div>
</template>

<script>
import ForeignersLogsFilters from './ForeignersLogsFilters.vue';
import LogsTable from '@/components/shared/AuditLogTable/LogsTable.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    LogsTable,
    ForeignersLogsFilters,
  },
  data() {
    return {
      isMoreLoading: false,
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
      logs: (state) => state.v2.admin.foreigners.logs.logs,
      filters: (state) => state.v2.admin.foreigners.logs.filters,
      page: (state) => state.v2.admin.foreigners.logs.page,
    }),
    ...mapGetters({
      isAuditSeveritiesEmpty: 'v2/shared/enums/isAuditSeveritiesEmpty',
    }),
  },

  watch: {
    filters: {
      deep: true,
      handler() {
        this.$store.commit('v2/admin/foreigners/logs/set', ['page', 1]);
        this.$store.dispatch('v2/admin/foreigners/logs/loadLogs', {
          foreignerId: this.foreigner.id,
        });
      },
    },
    page: {
      deep: true,
      async handler() {
        this.isMoreLoading = true;
        await this.$store.dispatch('v2/admin/foreigners/logs/loadLogs', {
          foreignerId: this.foreigner.id,
        });
        this.isMoreLoading = false;
      },
    },
  },

  mounted() {
    this.$store.dispatch('v2/admin/foreigners/logs/loadLogs', { foreignerId: this.foreigner.id });

    if (this.isAuditSeveritiesEmpty) {
      this.$store.dispatch('v2/shared/enums/loadAuditSeverities');
    }

    this.$store.dispatch('v2/shared/enums/loadForeignerAuditEvents');

    this.$store.dispatch('v2/admin/messaging/loadMessagingUsers', { foreignerId: this.foreigner.id });
  },

  methods: {
    sortChange({ prop, order }) {
      const payload = order ? `${order === 'descending' ? '-' : ''}${prop}` : '-action_date';

      this.$store.commit('v2/admin/foreigners/logs/updateFilter', { field: 'orderBy', payload });
    },

    loadMore() {
      this.$store.commit('v2/admin/foreigners/logs/set', ['page', this.page + 1]);
    },
  },
};
</script>

<style scoped>
:deep(.tw-group:hover .group-hover\:tw-h-auto) {
  height: auto !important;
}
</style>
